module.exports = __webpack_public_path__ + "img/time.b03e821c.svg";